import { createRoute, redirect } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import { ConfigurationLayout } from '@/features/configuration/configuration-layout';
import { CountryRiskSettings } from '@/features/configuration/country-risk-settings';
import { AppLayout } from '@/layouts/app-layout';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'configuration',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <AppLayout>
          <ConfigurationLayout />
        </AppLayout>
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: { titleKey: 'Configuration' },
});

export const IndexRoute = createRoute({
  getParentRoute: () => Route,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/configuration/country-risks', replace: true });
  },
});

export const CountryRisksRoute = createRoute({
  getParentRoute: () => Route,
  path: 'country-risks',
  component: CountryRiskSettings,
  staticData: { titleKey: 'Configuration' },
});
